import request from '@/lib/api'

const _BASE = "/api";

//获取应用列表
export function getApplist(data) {
  return request({
    url: `${_BASE}/tPmcApplication/list`,
    method: 'get',
    params: data
  })
}
//应用详情
export function getAppInfo(id) {
  return request({
    url: `${_BASE}/tPmcApplication/${id}`,
    method: 'get',
  })
}
//删除应用
export function deleteApp(id) {
  return request({
    url: `${_BASE}/tPmcApplication/${id}`,
    method: 'delete'
  })
}
//获取应用的服务列表
export function getServiceList(id) {
  return request({
    url: `${_BASE}/tPmcApplication/getServices/${id}`,
    method: 'get',
  })
}
//获取应用资源目录
export function getAppVideoTree(id, params) {
  return request({
    url: `${_BASE}/tPmcApplication/getResources/${id}`,
    method: 'get',
    params
  })
}
//查看摄像头
export function getVideoDetail(id, params) {
  return request({
    url: `${_BASE}/tPmcApplicationResource/getStreamInfo/${id}`,
    method: 'get',
    params
  })
}
//获取应用资源目录
export function getAppVideoTreeV2(id, params) {
  return request({
    url: `${_BASE}/tPmcApplication/getResources_v2/${id}`,
    method: 'get',
    params
  })
}
//根据名称或者通道id搜索
export function sipVideoSearch(id, params) {
  return request({
    url: `${_BASE}/tPmcApplication/search/${id}`,
    method: 'get',
    params
  })
}

// 边缘计算应用------

// 查询应用列表
export function getList(params) {
  return request({
    url: `${_BASE}/tPmcOutApplication/list`,
    method: 'get',
    params
  })
}

// 根据id删除应用
export function deleteTpmcOut(id) {
  return request({
    url: `${_BASE}/tPmcOutApplication/${id}`,
    method: 'delete'
  })
}

// 获取应用详情
export function getDetail(id) {
  return request({
    url: `${_BASE}/tPmcOutApplication/${id}`,
    method: 'get',
  })
}

// 获取边缘计算应用设备和事件数量
export function getCount(id) {
  return request({
    url: `${_BASE}/tPmcOutApplication/getCount/${id}`,
    method: 'get',
  })
}

// 获取设备列表
export function findBoxList(params) {
  return request({
    url: `${_BASE}/tPmcOutApplication/findBoxList`,
    method: 'get',
    params
  })
}

// 获取事件推送列表
export function getEventPushList(applicationId) {
  return request({
    url: `${_BASE}/tPmcApplication/getPushAddress/${applicationId}`
  })
}

// 1.1.1视频资源树更新
// 获取一级节点
export function getMyAppVideoTreeFirst(id, params) {
  return request({
    url: `${_BASE}/tpmcChannel/first/${id}`,
    method: 'get',
    params
  })
}
// 获取应用资源树
export function getMyAppVideoTree(groupId, parentId, applicationId) {
  return request({
    url: `${_BASE}/tpmcChannel/appTree/${groupId}/${parentId}/${applicationId}`,
    method: 'get',
  })
}
// 应用详情视频资源搜索
export function appInfoSelectTreeSearch(data) {
  data.host = location.hostname;
  return request({
    url: `${_BASE}/tpmcChannel/searchChannelInApp`,
    method: "post",
    data
  })
}